import { useState, useContext, useEffect, useMemo } from 'react';
import { IconButton, Dropdown, PersonAvatar, Button } from '@teo/components';
import { ArrowLeft, Sidebar } from '@teo/components/icons';
import { useGet } from '@/query/fetchHooks';
import { config } from '@/config';
import { useTranslation } from 'react-i18next';
import { useMobile, toPercent, nthIndexOf } from '@/util';
import { useNavigate } from 'react-router-dom';
import { axios } from '@/axios';
import { TinCanService } from '@/services/tincan.service';
import { AuthContext } from '@/components/Contexts/AuthContext';
import {
  sortDataLP,
  applyCompetenceSkips,
} from '@/components/LearningPath/util';

const LpButton = ({
  activeItem,
  course,
  nodeGroups,
  isNodeAvailable,
  toOverview,
  onClose,
  isAssessment = false,
}: any) => {
  const { t }: { t: any } = useTranslation();
  const navigate = useNavigate();
  const { auth } = useContext(AuthContext);

  const lpPath = window.location.pathname.slice(
    0,
    nthIndexOf(window.location.pathname, '/', 3)
  );

  const habdleBack = async () => {
    if (nodeGroups?.depth > 1) {
      if (isNodeAvailable && activeItem) {
        navigate(
          `${lpPath}/learning-paths/${nodeGroups?.lpgroupId}/themes/${course?.learningpathId}`
        );
      } else {
        navigate(`${lpPath}/learning-paths/${nodeGroups?.lpgroupId}`);
      }
    } else {
      navigate(`${lpPath}/learning-paths/${nodeGroups?.lpgroupId}`);
    }
  };

  // const habdleBack = async () => {
  //   if (isNodeAvailable && activeItem) {
  //     if (
  //       activeItem?.type == 'training' ||
  //       activeItem?.type == 'learningpath'
  //     ) {
  //       if (activeItem?.type == 'training') {
  //         const promises = [];
  //         promises.push(
  //           axios.post(`${config.backend}/trainingfollows`, {
  //             trainingId: activeItem?.objectId,
  //             userId: auth?.user?.id,
  //           })
  //         );
  //         Promise.allSettled(promises).then(() => {
  //           navigate(
  //             `${lpPath}/learning-paths/${nodeGroups?.lpgroupId}/${
  //               activeItem?.subType === 'milestone'
  //                 ? 'milestones'
  //                 : activeItem?.subType === 'evaluation'
  //                 ? 'evaluations'
  //                 : 'trainings'
  //             }/${activeItem?.objectId}`
  //           );
  //         });
  //       } else {
  //         navigate(
  //           `${lpPath}/learning-paths/${nodeGroups?.lpgroupId}/themes/${activeItem?.objectId}`
  //         );
  //       }
  //     } else {
  //       navigate(
  //         `${lpPath}/${
  //           activeItem?.subType === 'assessment'
  //             ? 'assessments'
  //             : activeItem?.subType === 'leervacature'
  //             ? 'vacancies'
  //             : 'courses'
  //         }/${activeItem?.objectId}`
  //       );
  //     }
  //   } else {
  //     navigate(`${lpPath}/learning-paths/${nodeGroups?.lpgroupId}`);
  //   }
  // };
  return (
    <>
      {isAssessment ? (
        <Button
          className="my-2"
          variant="outline"
          size="md"
          onClick={async () => await habdleBack()}
        >
          {t('pages.follow_learningpath.back_to_learning_path')}
        </Button>
      ) : (
        <Button
          className="my-2"
          variant="outline"
          size="md"
          onClick={async () => {
            if (toOverview) {
              await habdleBack();
              await onClose();
            } else {
              await habdleBack();
              await onClose();
            }
          }}
        >
          {isNodeAvailable && activeItem
            ? t('pages.follow_learningpath.continue_to_learning_path')
            : t('pages.follow_learningpath.back_to_learning_path')}
        </Button>
      )}
    </>
  );
};

export const CourseSuccess = ({ onClose, course, studentId }: any) => {
  const { t }: { t: any } = useTranslation();
  const navigate = useNavigate();
  const { auth, setAuth } = useContext(AuthContext);
  const authUser = auth?.user;

  const [student, setStudent] = useState<any>({});
  const [courseinfo, setCourseInfo] = useState<string>();
  const [passedMessage, setPassedMessage] = useState<string>();
  const [failedMessage, setFailedMessage] = useState<string>();
  const [notCorrectedMessage, setNotCorrectedMessage] = useState<string>();
  const [notCompletedMessage, setNotCompletedMessage] = useState<string>();
  const [assessmentMessage, setAssessmentMessage] = useState<string>();

  const [nodes, setNodes] = useState<any>(null);
  const [nodeGroups, setNodeGroups] = useState<any>(null);
  const [activeItem, setActiveItem] = useState<any>(null);

  const isMobile = useMobile();
  const basePath = window.location.pathname.slice(
    0,
    nthIndexOf(window.location.pathname, '/', 4)
  );

  const lpPath = window.location.pathname.slice(
    0,
    nthIndexOf(window.location.pathname, '/', 3)
  );

  useGet(`/nodegroups`, {
    enabled: !!course?.learningpathId,
    type: 'course',
    objectId: course?.id,
    userId: authUser?.id,
    onSuccess: (result: any) => {
      setNodeGroups(result?.data[0] || {});
    },
  });

  useGet(`/lpnodestatuses`, {
    // node_lpgroup_map rows have no id column; scope on the actual group.
    enabled: !!nodeGroups?.lpgroupId,
    lpgroupId: nodeGroups?.lpgroupId,
    userId: auth?.user?.id,
    onSuccess: async (res: any) => {
      const nodedetails = applyCompetenceSkips(
        res?.data?.filter(
          (el: any) =>
            el?.type !== 'root' && el?.learningpathId === course?.learningpathId
        )
      );
      if (nodedetails?.length > 0) {
        const sortData = sortDataLP(nodedetails);
        setNodes(sortData);

        let lastActive;

        const checkLastActive = sortData?.find(
          (nds: any) => nds.progress !== 1 && nds?.mandatory
        );

        if (checkLastActive?.subType === 'milestone') {
          const allBefore = getAllBeforeById(sortData, checkLastActive?.id);
          const allOk = areAllPassed(allBefore);
          if (allOk) {
            lastActive = checkLastActive;
          } else {
            lastActive = sortData?.find(
              (nds: any) =>
                nds.progress !== 1 &&
                nds?.mandatory &&
                nds?.subType !== 'milestone'
            );
          }
        } else {
          lastActive = checkLastActive;
        }

        // const notCorrectedActive = sortData?.find(
        //   (nds: any) =>
        //     nds.progress === 1 &&
        //     nds?.mandatory &&
        //     nds?.subType !== 'milestone' &&
        //     !nds.isCorrected
        // );

        const notPassedActive = sortData?.find(
          (nds: any) =>
            nds.progress === 1 &&
            nds?.mandatory &&
            nds?.subType !== 'milestone' &&
            nds.isCorrected &&
            nds.maxScore > 0 &&
            nds.score / nds.maxScore < nds.minScore
        );
        setActiveItem(
          lastActive ? lastActive : notPassedActive ? notPassedActive : null
        );
      }
    },
  });

  const nodeById = useMemo(() => {
    if (nodes?.length > 0) {
      const map = new Map();
      nodes.forEach((it: any) => map.set(it.id, it));
      return map;
    }
  }, [nodes]);

  function getAllBeforeById(items: any, nodeId: any) {
    const byId = new Map(items.map((item: any) => [item.id, item]));
    const start = items.find((item: any) => item.id === nodeId);

    if (!start) return [];

    const result: any = [];
    const visited = new Set();

    function walk(node: any) {
      if (!node?.roots?.length) return;

      for (const parentId of node.roots) {
        if (visited.has(parentId)) continue;
        visited.add(parentId);

        const parent = byId.get(parentId);
        if (parent) {
          result.push(parent);
          walk(parent);
        }
      }
    }

    walk(start);
    return result;
  }

  function areAllPassed(arr: any) {
    return arr.every((item: any) => {
      if (item?.skippedByCompetences) return true;
      const hasProgress = item.progress === 1;
      const hasScore =
        item.maxScore === 0 && item.score === 0 && item?.isCorrected
          ? true
          : item.minScore > 0
          ? item.score / item.maxScore >= item?.minScore
          : true;
      return hasProgress && hasScore && item?.isCorrected;
    });
  }

  function findRealParent(arr: any[], nodeId: any): any | null {
    const node = arr.find((n: any) => n.id == nodeId);
    if (!node) return null;

    if (node.subType !== 'milestone') return node;

    if (!node.roots?.length) return null;

    return findRealParent(arr, node.roots[0]);
  }

  const areMandatoryRootsDone = (n: any) => {
    const roots = n?.roots || [];
    if (roots.length === 0) return true;

    const mandatoryRoots = roots.filter(
      (rid: any) => nodeById?.get(rid)?.mandatory !== false
    );

    if (mandatoryRoots.length === 0) return true;

    return mandatoryRoots.every((rid: any) => {
      const parent = nodeById?.get(rid);
      if (!parent) return true;

      if (n?.subType === 'milestone') {
        const allBefore = getAllBeforeById(nodes, n?.id);
        const allOk = areAllPassed(allBefore);
        if (!allOk) {
          return false;
        }
      }

      if (!parent?.blocking) return true;
      if (parent?.blocking && !parent?.notCompleted && !parent?.notPassed)
        return true;

      if (parent?.subType === 'milestone') return true;

      if (parent?.subType === 'milestone') return true;

      if (parent.notPassed === false) {
        return parent.progress === 1;
      }
      if (parent.notPassed === true) {
        const hasProgress = parent.progress === 1;
        const enoughScore =
          parent.maxScore > 0
            ? parent.score / parent.maxScore >= parent.minScore
            : false;
        return hasProgress && enoughScore;
      }

      return false;
    });
  };

  function comesAfterPassNode(arr: any, node: any) {
    const index = arr.findIndex((item: any) => item.id === node?.id);
    if (index === 0) return true;
    if (!node?.roots?.length) return true;

    let passed = 0;
    for (const rootId of node.roots) {
      const realParent = findRealParent(arr, rootId);
      if (realParent?.progress === 1) passed++;
    }
    return passed === node.roots.length;
  }

  const isNodeAvailable = (n: any) => {
    return (
      // lpGroup?.order === 'flexible' ||
      // (areMandatoryRootsDone(n) && comesAfter(items, n?.id, notPassedNode?.id))
      areMandatoryRootsDone(n) && comesAfterPassNode(nodes, n)
    );
  };

  useEffect(() => {
    if (student.courseId) {
      axios.put(
        `${config.backend}/follow/${student.courseId}/${student.userId}`,
        {
          currentLessonId: null,
        }
      );
      const tincan = TinCanService.getInstance();
      tincan.reportStatus(student, course);
    }
  }, [student]);

  useGet(`/courseinfo/${course?.id}`, {
    enabled: !!course?.id,
    onSuccess: (result: any) => {
      setCourseInfo(result?.data);
      result?.data?.lvCompletePassed &&
        setPassedMessage(result?.data?.lvCompletePassed);
      result?.data?.lvCompleteFailed &&
        setFailedMessage(result?.data?.lvCompleteFailed);
    },
  });

  useGet(`/student/${course?.id}/${studentId}`, {
    enabled: !!course?.id && !!studentId,
    onSuccess: (result: any) => {
      setStudent(result?.data);
      !passedMessage &&
        setPassedMessage(
          t(
            'pages.course_content_flow.step_4.message_passed_default',
            result?.data
          )
        );
      !failedMessage &&
        setFailedMessage(
          t(
            'pages.course_content_flow.step_4.message_failed_default',
            result?.data
          )
        );
      !notCorrectedMessage &&
        setNotCorrectedMessage(
          t(
            'pages.course_content_flow.step_4.message_notcorrected_default',
            result?.data
          )
        );
      !notCorrectedMessage &&
        setNotCompletedMessage(
          t(
            'pages.course_content_flow.step_4.message_notcompleted_default',
            result?.data
          )
        );
      !notCorrectedMessage &&
        setAssessmentMessage(
          t(
            'pages.course_content_flow.step_4.message_assessment_default',
            result?.data
          )
        );
    },
  });

  let score = (student.score || 0) / (student.maxScore || 0);
  const isAssessment = course?.courseType === 'assessment';

  let autoCorrect = course?.correctionType !== 'manual';
  let toOverview =
    course?.correctionType === 'manual' || course?.correctionType === 'auto';

  const tincan = TinCanService.getInstance();
  tincan.reportStatus(student, course);

  let allowBack = true;
  let showCloseMessage = false;
  if (tincan.available()) {
    allowBack = false;
    showCloseMessage = true;
    toOverview = false;
  }

  if ((student.maxScore || 0) === 0) {
    score = 1;
    autoCorrect = true;
    // isAssessment = true;
  }
  const hasPassed = score >= course?.minScore;
  let incomplete = false;

  if (student?.status !== 'done') {
    incomplete = true;
  }

  let message, image;

  if (autoCorrect) {
    if (student?.status === 'done' && student?.tasksRemaining === 0) {
      if (hasPassed) {
        message = passedMessage;
        image = '/images/courseSuccess.svg';
      } else {
        message = failedMessage;
        image = '/images/courseFailure.svg';
      }
    } else {
      message = notCompletedMessage;
      image = '/images/courseSuccess.svg';
    }
  } else {
    message = notCorrectedMessage;
    image = '/images/courseSuccess.svg';
  }
  if (isAssessment) {
    message = assessmentMessage;
    image = '/images/courseSuccess.svg';
    toOverview = true;
  }

  message = message?.replace('{firstName}', student?.firstName || '');
  message = message?.replace(
    '{score_placeholder}',
    toPercent(course?.minScore).toString()
  );

  if (!student?.id) return null;

  return (
    <div className="flex min-h-screen w-full flex-col">
      <header
        className="sticky top-0 z-10 flex h-[80px] min-h-16 items-center justify-start border-b border-solid border-grey-02 bg-white p-3"
        data-testid="header"
      >
        <div data-testid="backOnCourse">
          {allowBack && (
            <IconButton
              className="my-auto mx-2"
              Icon={ArrowLeft}
              variant="outline"
              onClick={onClose}
            />
          )}
        </div>
      </header>

      <div className="flex w-full">
        <div className="mx-auto flex max-w-3xl flex-col items-center gap-8 px-4">
          <img className="mt-4 w-[300px]" src={image}></img>
          <span
            className="text-3xl-semibold"
            dangerouslySetInnerHTML={{
              __html: message as string,
            }}
          ></span>
          {incomplete && (
            <div className={'my-5 w-full rounded-lg border p-4'}>
              <div className="py-2 text-sm font-semibold">
                {t('pages.feedback.notcompleted', { courseName: course?.name })}
              </div>
              {course?.learningpathId ? (
                <>
                  {nodes?.length > 0 && (
                    <LpButton
                      activeItem={activeItem}
                      course={course}
                      nodeGroups={nodeGroups}
                      isNodeAvailable={isNodeAvailable(activeItem)}
                      toOverview={toOverview}
                      onClose={onClose}
                    />
                  )}
                </>
              ) : (
                <Button
                  className="my-2"
                  variant="outline"
                  size="md"
                  onClick={async () => {
                    await navigate(`${basePath}`);
                    await onClose();
                  }}
                >
                  {t('navigation.back')}
                </Button>
              )}
            </div>
          )}
          {!isAssessment && !incomplete && (
            <div className={'my-5 w-full rounded-lg border p-4'}>
              <div className="py-2 text-sm font-semibold">
                {t('pages.feedback.completed', { courseName: course?.name })}
              </div>
              {autoCorrect &&
                student?.status === 'done' &&
                student?.tasksRemaining === 0 && (
                  <div className="py-2 text-sm font-normal text-[#3257fc]">
                    {t('widgets.type.final_score')}
                    &nbsp;
                    <span className="font-semibold">
                      {toPercent(student?.score, student?.maxScore)}%
                    </span>
                  </div>
                )}
              {showCloseMessage && (
                <div className="py-2 text-sm font-semibold">
                  {t('pages.feedback.close')}
                </div>
              )}
              {course?.learningpathId ? (
                <>
                  {nodes?.length > 0 && (
                    <LpButton
                      activeItem={activeItem}
                      course={course}
                      nodeGroups={nodeGroups}
                      isNodeAvailable={isNodeAvailable(activeItem)}
                      toOverview={toOverview}
                      onClose={onClose}
                    />
                  )}
                </>
              ) : (
                <Button
                  className="my-2"
                  variant="outline"
                  size="md"
                  onClick={async () => {
                    if (toOverview) {
                      await navigate(`${basePath}`);
                      await onClose();
                    } else {
                      await onClose();
                    }
                  }}
                >
                  {toOverview
                    ? t('widgets.type.to_overview')
                    : t('widgets.type.view_your_answers_button')}
                </Button>
              )}
            </div>
          )}
          {isAssessment && (
            <div className={'my-5 w-full rounded-lg border p-4'}>
              {course?.learningpathId ? (
                <>
                  {nodes?.length > 0 && (
                    <LpButton
                      activeItem={activeItem}
                      course={course}
                      nodeGroups={nodeGroups}
                      isNodeAvailable={isNodeAvailable(activeItem)}
                      toOverview={toOverview}
                      onClose={onClose}
                      isAssessment={isAssessment}
                    />
                  )}
                </>
              ) : (
                <Button
                  className="my-2"
                  variant="outline"
                  size="md"
                  onClick={async () => await navigate(`${basePath}`)}
                >
                  {t('widgets.type.to_overview')}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
